module.exports = __webpack_public_path__ + "static/media/paperclip-2.35e30a7e.svg";